import NullValidator from './NullValidator';

export default class Helpers {
  static get nullValidator() {
    return new NullValidator();
  }
}
